var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5165 0L35.0547 20.3197L40.1615 8.34475L62.5165 0Z",
    fill: "#E17726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54775 0.0239868L23.843 8.34624L28.692 20.4782L1.54775 0.0239868ZM51.465 43.2145L63.6027 43.4455L59.3607 57.856L44.55 53.7782L51.465 43.2145ZM12.5347 43.2145L19.424 53.7782L4.63825 57.8562L0.421997 43.4455L12.5347 43.2145Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0327 17.388L28.5287 33.4087L13.6859 32.7335L17.9079 26.364L17.9614 26.3027L28.0327 17.388ZM35.8134 17.2092L46.0384 26.3032L46.0914 26.3642L50.3134 32.7337L35.4739 33.4087L35.8134 17.2092ZM19.8587 43.261L27.9632 49.5757L18.5487 54.121L19.8587 43.261ZM44.1427 43.26L45.4254 54.1212L36.0372 49.5752L44.1427 43.26Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2444 48.9805L45.7712 53.5935L36.9094 57.805L37.0014 55.0215L36.2444 48.9805ZM27.7527 48.9825L27.0254 54.976L27.0852 57.8017L18.2027 53.5935L27.7527 48.9825Z",
    fill: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0018 35.4998L27.4913 40.7318L19.0155 38.2488L25.0018 35.4998ZM38.998 35.5003L45.0125 38.2488L36.509 40.7311L38.998 35.5003Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5066 43.2075L19.1366 54.4675L11.7933 43.4537L20.5066 43.2075ZM43.4941 43.2077L52.2076 43.4537L44.8368 54.468L43.4941 43.2077ZM50.5281 32.0967L44.1868 38.5595L39.2976 36.3252L36.9568 41.2462L35.4223 32.784L50.5281 32.0967ZM13.4688 32.0967L28.5776 32.784L27.0428 41.2462L24.7016 36.326L19.8383 38.5597L13.4688 32.0967Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0416 30.7705L20.2161 38.0508L20.4646 45.238L13.0416 30.7705ZM50.9658 30.7575L43.5293 45.2508L43.8093 38.0508L50.9658 30.7575ZM28.2268 31.214L28.5156 33.0315L29.2291 37.5593L28.7703 51.4655L26.6016 40.2943L26.6008 40.1788L28.2268 31.214ZM35.7696 31.1888L37.3998 40.1788L37.3991 40.2943L35.2248 51.4935L35.1388 48.6923L34.7996 37.4768L35.7696 31.1888Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.447 37.7615L44.2043 44.006L36.6358 49.9028L35.1058 48.8218L36.8208 39.988L44.447 37.7615ZM19.5793 37.7615L27.179 39.988L28.894 48.8218L27.364 49.9028L19.7953 44.0055L19.5793 37.7615Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7545 52.2145L26.4375 56.8025L26.3965 54.8432L27.2067 54.132H36.7902L37.6297 54.8407L37.5677 56.7985L47.1895 52.226L42.5075 56.095L36.8462 59.9832H27.129L21.4715 56.079L16.7545 52.2145Z",
    fill: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.551 48.3698L36.92 49.337L37.7222 55.738L36.5612 54.7578H27.4422L26.3032 55.7578L27.0792 49.3375L28.4487 48.3698H35.551Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7035 0.562439L64 10.4517L61.9413 20.4509L63.4073 21.5817L61.4235 23.0952L62.9145 24.2467L60.9403 26.0444L62.1523 26.9222L58.9358 30.6787L45.7433 26.8374L45.629 26.7762L36.1223 18.7567L60.7035 0.562439ZM3.29653 0.562439L27.878 18.7567L18.371 26.7762L18.2568 26.8374L5.06428 30.6787L1.84778 26.9222L3.05878 26.0452L1.08578 24.2467L2.57378 23.0964L0.560281 21.5787L2.08153 20.4472L3.05176e-05 10.4522L3.29653 0.562439Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.098 25.9975L59.0763 30.0672L63.6175 44.0637H51.6365L43.3815 44.1677L49.385 32.4657L45.098 25.9975ZM18.902 25.9975L14.6143 32.4657L20.6185 44.1677L12.3673 44.0637H0.407776L4.92353 30.0675L18.902 25.9975ZM40.846 8.27795L36.9363 18.8377L36.1065 33.1027L35.789 37.574L35.7638 48.996H28.236L28.2115 37.5955L27.893 33.099L27.063 18.8377L23.1538 8.27795H40.846Z",
    fill: "#F5841F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/Metamask.fb5a4675d404bfa6015b13e63380d1e8.svg";
export { ForwardRef as ReactComponent };